import { render, staticRenderFns } from "./NormalSearchNav227.vue?vue&type=template&id=0ba01967&scoped=true&"
import script from "./NormalSearchNav227.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav227.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba01967",
  null
  
)

export default component.exports